import { baseUrl } from "./constants";
import { storeUser, clearUser } from "./storage";
import { notify } from "../components/notification";

export async function login({ username, password }) {
  let response = await (await fetch(`${baseUrl}/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, password })
  })).json();

  if (response.success !== 1) {
    notify(response.msg || response.error, "error");
    throw new Error(response.msg || response.error);
  } else {
    let { user, token } = response;
    await storeUser(user, token);
    return response;
  }
}

export async function logout() {
  await clearUser();
}



// WEBPACK FOOTER //
// ./src/backend/login.js